module.exports = __webpack_public_path__ + "03_glasses_brown.62d9b4a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer4/03_glasses_brown.png
// module id = 9lky
// module chunks = 0